import React from 'react';
import { useTranslation } from 'react-i18next';

import ConsumerHeader from '../../../consumer-header/ConsumerHeader';

import scss from './Header.module.scss';

function Header() {
  const { t } = useTranslation('projects');

  return (
    <ConsumerHeader>
      <div className={scss.projectName}>
        <h3>{t('finalMessages')}</h3>
      </div>
    </ConsumerHeader>
  );
}

export default Header;
